import {
  ASSIGN_REPORT_TEMPLATE_GROUP_GET_GROUP_LIST_INIT,
  ASSIGN_REPORT_TEMPLATE_GROUP_GET_GROUP_LIST_SUCCESS,
  ASSIGN_REPORT_TEMPLATE_GROUP_GET_GROUP_LIST_FAILURE,
  ASSIGN_REPORT_TEMPLATE_GROUP_GET_GROUP_REPORT_TEMPLATES_LIST_INIT,
  ASSIGN_REPORT_TEMPLATE_GROUP_GET_GROUP_REPORT_TEMPLATES_LIST_SUCCESS,
  ASSIGN_REPORT_TEMPLATE_GROUP_GET_GROUP_REPORT_TEMPLATES_LIST_FAILURE,
  ASSIGN_REPORT_TEMPLATE_GROUP_GET_REPORT_TEMPLATE_LIST_INIT,
  ASSIGN_REPORT_TEMPLATE_GROUP_GET_REPORT_TEMPLATE_LIST_SUCCESS,
  ASSIGN_REPORT_TEMPLATE_GROUP_GET_REPORT_TEMPLATE_LIST_FAILURE,
  ASSIGN_REPORT_TEMPLATE_GROUP_GET_REPORT_TEMPLATE_GROUPS_LIST_INIT,
  ASSIGN_REPORT_TEMPLATE_GROUP_GET_REPORT_TEMPLATE_GROUPS_LIST_SUCCESS,
  ASSIGN_REPORT_TEMPLATE_GROUP_GET_REPORT_TEMPLATE_GROUPS_LIST_FAILURE,
  ASSIGN_REPORT_TEMPLATE_GROUP_SAVE_GROUP_REPORT_TEMPLATE_INIT,
  ASSIGN_REPORT_TEMPLATE_GROUP_SAVE_GROUP_REPORT_TEMPLATE_SUCCESS,
  ASSIGN_REPORT_TEMPLATE_GROUP_SAVE_GROUP_REPORT_TEMPLATE_FAILURE,
  ASSIGN_REPORT_TEMPLATE_GROUP_SAVE_REPORT_TEMPLATE_GROUP_INIT,
  ASSIGN_REPORT_TEMPLATE_GROUP_SAVE_REPORT_TEMPLATE_GROUP_SUCCESS,
  ASSIGN_REPORT_TEMPLATE_GROUP_SAVE_REPORT_TEMPLATE_GROUP_FAILURE,
  ASSIGN_REPORT_TEMPLATE_GROUP_DOWNLOAD_IMPORT_FILE_INIT,
  ASSIGN_REPORT_TEMPLATE_GROUP_DOWNLOAD_IMPORT_FILE_SUCCESS,
  ASSIGN_REPORT_TEMPLATE_GROUP_DOWNLOAD_IMPORT_FILE_FAILURE,
  ASSIGN_REPORT_TEMPLATE_GROUP_IMPORT_INIT,
  ASSIGN_REPORT_TEMPLATE_GROUP_IMPORT_SUCCESS,
  ASSIGN_REPORT_TEMPLATE_GROUP_IMPORT_FAILURE,
  ASSIGN_REPORT_TEMPLATE_GROUP_IMPORT_RESET,
  ASSIGN_REPORT_TEMPLATE_GROUP_RESET,
  ASSIGN_REPORT_TEMPLATE_GROUP_SOFT_RESET
} from './types';
import ActionsTooling from '../../../tooling/actionsTooling';
import FilesTooling from '../../../tooling/filesTooling';
import { intl } from '../../../locales/localesConfig';

export function resetAssignReportTemplateGroupAdmin() {
  return {
    type: ASSIGN_REPORT_TEMPLATE_GROUP_RESET
  };
}

export function softResetAssignReportTemplateGroupAdmin() {
  return {
    type: ASSIGN_REPORT_TEMPLATE_GROUP_SOFT_RESET
  };
}

export function getGroupList(params, paging = false) {
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: ASSIGN_REPORT_TEMPLATE_GROUP_GET_GROUP_LIST_INIT,
      params: params,
      paging: paging
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/group/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(ASSIGN_REPORT_TEMPLATE_GROUP_GET_GROUP_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(ASSIGN_REPORT_TEMPLATE_GROUP_GET_GROUP_LIST_FAILURE, error));
    }  
  };
}

export function getReportTemplateList(params, paging = false) {
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: ASSIGN_REPORT_TEMPLATE_GROUP_GET_REPORT_TEMPLATE_LIST_INIT,
      params: params,
      paging: paging
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/reporttemplate/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(ASSIGN_REPORT_TEMPLATE_GROUP_GET_REPORT_TEMPLATE_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(ASSIGN_REPORT_TEMPLATE_GROUP_GET_REPORT_TEMPLATE_LIST_FAILURE, error));
    }  
  };
}

export function getGroupReportTemplatesList(params, paging = false) {
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: ASSIGN_REPORT_TEMPLATE_GROUP_GET_GROUP_REPORT_TEMPLATES_LIST_INIT,
      params: params,
      paging: paging
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/group/getreporttemplates",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(ASSIGN_REPORT_TEMPLATE_GROUP_GET_GROUP_REPORT_TEMPLATES_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(ASSIGN_REPORT_TEMPLATE_GROUP_GET_GROUP_REPORT_TEMPLATES_LIST_FAILURE, error));
    }  
  };
}

export function getReportTemplateGroupsList(params, paging = false) {
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: ASSIGN_REPORT_TEMPLATE_GROUP_GET_REPORT_TEMPLATE_GROUPS_LIST_INIT,
      params: params,
      paging: paging
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/reporttemplate/getgroups",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(ASSIGN_REPORT_TEMPLATE_GROUP_GET_REPORT_TEMPLATE_GROUPS_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(ASSIGN_REPORT_TEMPLATE_GROUP_GET_REPORT_TEMPLATE_GROUPS_LIST_FAILURE, error));
    }  
  };
}

export function saveGroupReportTemplate(data) {
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: ASSIGN_REPORT_TEMPLATE_GROUP_SAVE_GROUP_REPORT_TEMPLATE_INIT,
      params: data
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        data.add == true ? "/api/group/addreporttemplate" : "/api/group/removereporttemplate",
        data.add == true ? "PUT" : "DELETE",
        null,
        data
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(ASSIGN_REPORT_TEMPLATE_GROUP_SAVE_GROUP_REPORT_TEMPLATE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(ASSIGN_REPORT_TEMPLATE_GROUP_SAVE_GROUP_REPORT_TEMPLATE_FAILURE, error));
    }  
  };
}

export function saveReportTemplateGroup(data) {
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: ASSIGN_REPORT_TEMPLATE_GROUP_SAVE_REPORT_TEMPLATE_GROUP_INIT,
      params: data
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        data.add == true ? "/api/reporttemplate/addgroup" : "/api/reporttemplate/removegroup",
        data.add == true ? "PUT" : "DELETE",
        null,
        data
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(ASSIGN_REPORT_TEMPLATE_GROUP_SAVE_REPORT_TEMPLATE_GROUP_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(ASSIGN_REPORT_TEMPLATE_GROUP_SAVE_REPORT_TEMPLATE_GROUP_FAILURE, error));
    }  
  };
}

export function downloadImportFile(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(ASSIGN_REPORT_TEMPLATE_GROUP_DOWNLOAD_IMPORT_FILE_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/group/downloadreporttemplatesassignsimportfile",
        "GET",
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(ASSIGN_REPORT_TEMPLATE_GROUP_DOWNLOAD_IMPORT_FILE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(ASSIGN_REPORT_TEMPLATE_GROUP_DOWNLOAD_IMPORT_FILE_FAILURE, error));
    }  
  };
}

export function importAssigns(files) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(ASSIGN_REPORT_TEMPLATE_GROUP_IMPORT_INIT));
    try {
      const resp = await FilesTooling.uploadMutipleFilesClientSide(
        "/api/group/importreporttemplatesassigns",
        files
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(ASSIGN_REPORT_TEMPLATE_GROUP_IMPORT_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(ASSIGN_REPORT_TEMPLATE_GROUP_IMPORT_FAILURE, error));
    }  
  };
}

export function resetImport() {
  return {
    type: ASSIGN_REPORT_TEMPLATE_GROUP_IMPORT_RESET
  };
}


// WEBPACK FOOTER //
// ./source/client/actions/assignReportTemplateGroupAdmin/index.js